function findDuplicates(array) {
  return [
    ...new Set(array.filter((item, index) => array.indexOf(item) !== index)),
  ];
}
export default findDuplicates;
